<template>
  <section style="width: min(92vw, 500px)">
    <b-loading :is-full-page="false" :active.sync="isLoading"></b-loading>
    <form action v-on:submit.prevent="login">
      <div class="modal-card" style="width: auto">
        <header class="modal-card-head">
          <p>Su sesión ha expirado, por favor ingresar nuevamente sus credenciales</p>
        </header>
        <section class="modal-card-body">
          <div class="field">
            <label for="relogin-rut" class="label">RUT</label>
            <div class="control">
              <input
                id="relogin-rut"
                class="input"
                type="text"
                :value="formattedRut"
                @input="onRutInput"
                placeholder="12.345.678-9"
                autocomplete="username"
                autocapitalize="characters"
                spellcheck="false"
                maxlength="12"
                required
              />
            </div>
          </div>
          <b-field label="Contraseña">
            <b-input
              type="password"
              v-model="password"
              placeholder="Contraseña"
              required
            ></b-input>
          </b-field>
          <div class="field">
            <b-message type="is-danger" v-if="error">
            {{error}}
            </b-message>
            <!-- <label class="checkbox"></label> -->
          </div>
        </section>
        <footer class="modal-card-foot">
          <button class="button is-primary" type="submit" :disabled="isLoading">{{ isLoading ? 'Ingresando...' : 'Ingresar' }}</button>
        </footer>
      </div>
    </form>
  </section>
</template>

<script>
import { formatRut, normalizeRut } from "../utils/rut";

export default {
  data() {
    return {
      isLoading: false,
      rut: "",
      password: "",
      grant_type: "password",
      error: "",
    };
  },
  computed: {
    formattedRut() {
      return formatRut(this.rut);
    },
  },
  methods: {
    onRutInput(event) {
      const input = event.target;
      const charactersBeforeCaret = normalizeRut(input.value.slice(0, input.selectionStart)).length;
      this.rut = normalizeRut(input.value);
      this.$nextTick(() => {
        input.value = this.formattedRut;
        let caret = 0;
        let characters = 0;
        while (caret < input.value.length && characters < charactersBeforeCaret) {
          if (/[0-9K]/.test(input.value.charAt(caret))) characters++;
          caret++;
        }
        input.setSelectionRange(caret, caret);
      });
    },
    login() {
      if (this.isLoading) return;
      this.error = "";
      this.isLoading = true;
      this.$http
        .post("api/auth", {
          rut: normalizeRut(this.rut),
          password: this.password,
          grant_type: this.grant_type,
        })
        .then((response) => {
          let token = response.body.token;
          window.localStorage.setItem(
            "token",
            token
          );
          window.localStorage.setItem("perfil",response.body.user.role.type);
          window.localStorage.setItem("user",JSON.stringify(response.body.user));
          window.localStorage.setItem(
            "userName",
            `${response.body.user.name} ${response.body.user.pather_lastname} ${response.body.user.mother_lastname}`
          );
          window.location.reload();
        })
        .catch(() => {
          this.isLoading = false;
          this.error="RUT o contraseña incorrectos.";
        });
    }
  },
};
</script>
